import { render, staticRenderFns } from "./DetailExperience.vue?vue&type=template&id=09db0068&"
import script from "./DetailExperience.vue?vue&type=script&lang=js&"
export * from "./DetailExperience.vue?vue&type=script&lang=js&"
import style0 from "./DetailExperience.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports